import React from 'react';
import {
  Card,
  CardContent,
  Grid,
  Typography,
  Zoom,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

import {
  DEFAULT_FADE_DELAY,
  formBackground,
  FULL_HEIGHT,
} from '../utils/constants';

/**
 * Layout component to display a centered form without an image
 * @param {*} props
 * @returns
 */
function CenteredForm(props) {
  const title = props?.title ?? undefined;
  const children = props?.children ?? {};
  const hasBg = props?.bg ?? false;
  const theme = useTheme();

  return (
    <Grid
      container
      spacing={0}
      direction="column"
      alignItems="center"
      justifyContent="center"
      sx={{
        minHeight: FULL_HEIGHT,
        background: hasBg ? formBackground : theme.palette.white.main,
      }}
    >
      <Grid item xs={3}>
        <Zoom
          in={true}
          style={{ transitionDelay: DEFAULT_FADE_DELAY }}
        >
          <Card>
            {title && <Typography variant="h2">{title}</Typography>}
            <CardContent>{children}</CardContent>
          </Card>
        </Zoom>
      </Grid>
    </Grid>
  );
}

export default CenteredForm;
